export default {
    "test": "test",
    "ar": {
        "menu": [
            {
                "name": "HOME",
                "path": "/"
            },
            {
                "name": "MOVIES",
                "path": "/movies"
            },
            {
                "name": "CINEMAS",
                "path": "/cinemas"
            },
            {
                "name": "PROMOTIONS",
                "path": "/promotions"
            }
        ],
        "signUpPopUp": {
            "header": "arabic hello"
        },
        "NowShowing": "يعرض الآن"
    },
    "en": {
        "menu": [
            {
                "name": "HOME",
                "path": "/"
            },
            {
                "name": "MOVIES",
                "path": "/movies"
            },
            {
                "name": "CINEMAS",
                "path": "/cinemas"
            }
        ],
        "signUpPopUp": {
            "title": "english hello"
        },
        "NowShowing": "Now Showing"
    }
}


// WEBPACK FOOTER //
// ./src/languageDataTicketak.js